/** 与 embed / Drawer 共用的移动端断点 */
export const MOBILE_MAX_WIDTH = 768;

export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= MOBILE_MAX_WIDTH;
}
